export default () => {
  window.onNuxtReady(() => {
    // Defer loading of push notifications script until after app is fully interactive
    if (window.requestIdleCallback) {
      window.requestIdleCallback(loadPusher);
    } else {
      setTimeout(loadPusher, 2000);
    }
  });

  function loadPusher() {
    if (document.getElementById("pusher-beams-script")) return;
    const script = document.createElement("script");
    script.id = "pusher-beams-script";
    script.src = "https://js.pusher.com/beams/1.0/push-notifications-cdn.js";
    script.async = true;
    document.head.appendChild(script);
  }
};
